<template>
  <BaseSlideOverModal
    v-model:is-modal-open="localOpen"
    width="3xl"
    :title="supplierOrder.name"
    @close="close"
  >
    <template #cta>
      <div class="mr-6 flex gap-x-2">
        <BaseButton
          :title="$t('button.save')"
          icon="paper-plane"
          size="small"
          @click="handleReceiveOrder"
        />
      </div>
    </template>

    <template #body>
      <div class="scrollbar-custom mx-2 flex w-full flex-col overflow-auto">
        <h3 class="text-2xl font-bold text-gray-700">
          {{ $t('attribute.receive_order') }} :
          {{
            supplierOrder.id
              ? supplierOrder?.recipient?.name
              : $t('global.new_supplier_order')
          }}
        </h3>
        <div class="ml-2 mr-2 mt-4">
          <BaseShowEditDateTimePicker
            v-model:date="supplierOrder.delivery_date_time"
            v-model:time-undefined="
              supplierOrder.delivery_date_time_undefined_time
            "
            :label-date="$t('attribute.delivery_date_time')"
            name="delivery_date"
            :edition-mode="true"
            :errors="errors?.delivery_date_time"
          />

          <div class="form-help -mt-0.5 ml-3 text-red-600">
            {{ errors?.delivery_date_time?.join() }}
          </div>
        </div>
        <div class="mt-5 flex flex-col">
          <div class="flex justify-end">
            <BaseButton
              :title="$t('global.receive_all_order')"
              size="small"
              @click="receiveAllOrder"
            />
          </div>
          <table class="min-w-full table-auto divide-y divide-gray-300">
            <thead class="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  class="w-1/6 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 capitalize-first sm:pl-6"
                >
                  {{ $t('global.supplier_ref') }}
                </th>
                <th
                  scope="col"
                  class="w-1/4 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 capitalize-first sm:pl-6"
                >
                  {{ $t('attributes.items') }}
                </th>
                <th
                  scope="col"
                  class="w-1/6 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 capitalize-first"
                >
                  {{ $t('global.price_htva') }}
                </th>
                <th
                  scope="col"
                  class="w-1/6 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 capitalize-first"
                >
                  {{ $t('ordered_quantity') }}
                </th>
                <th
                  scope="col"
                  class="w-1/6 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 capitalize-first"
                >
                  {{ $t('item.received') }}
                </th>
                <th
                  scope="col"
                  class="w-1/12 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 capitalize-first"
                >
                  {{ $t('global.action') }}
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
              <template
                v-for="(
                  supplier_order_item, index
                ) in supplierOrder.supplierOrderItems"
                :key="index"
              >
                <tr>
                  <td
                    class="w-1/6 whitespace-normal py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                  >
                    <!-- Contenu -->
                  </td>
                  <td
                    class="w-1/4 whitespace-normal px-3 py-4 text-left text-sm font-bold text-gray-500"
                  >
                    {{ supplier_order_item.name }}
                  </td>
                  <td
                    class="w-1/6 whitespace-normal px-3 py-4 text-sm text-gray-500"
                  >
                    <div class="flex">
                      <BaseShowEditInput
                        v-model="supplier_order_item.price_htva"
                        name="quantity"
                        size="extra-small"
                        class="w-6 text-center"
                      />
                    </div>
                  </td>
                  <td
                    class="w-1/6 whitespace-normal px-3 py-4 text-center text-sm text-gray-500"
                  >
                    {{ supplier_order_item.quantity }}
                  </td>
                  <td
                    class="w-1/6 whitespace-normal px-3 py-4 text-center text-sm text-gray-500"
                  >
                    <div
                      class="text-sm font-medium text-gray-900 capitalize-first"
                    >
                      <input
                        :id="supplier_order_item.id"
                        class="ml-6 h-4 w-4 rounded bg-gray-100 text-blue-600"
                        type="checkbox"
                        :disabled="
                          save_item_receive.includes(supplier_order_item.id)
                        "
                        :checked="
                          items.includes(supplier_order_item.id) ||
                          save_item_receive.includes(supplier_order_item.id)
                        "
                        @click="toggleReceivingOrder(supplier_order_item)"
                      />
                    </div>
                  </td>
                  <td
                    class="w-1/12 whitespace-normal px-3 text-center text-sm text-gray-500"
                  >
                    <BaseButton
                      v-if="canDeleteItem(supplier_order_item)"
                      icon="trash"
                      color="danger"
                      size="extra-small"
                      @click="deleteItem(index)"
                    />
                  </td>
                </tr>
                <tr
                  v-if="
                    errors && errors[`supplierOrderItems.${index}.price_htva`]
                  "
                >
                  <td
                    colspan="6"
                    class="border-t border-transparent text-center text-xs text-red-600"
                  >
                    <div class="-mt-6 ml-7">
                      {{
                        errors[`supplierOrderItems.${index}.price_htva`].join(
                          ', '
                        )
                      }}
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </BaseSlideOverModal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import BaseSlideOverModal from '@c/addf-package/components/modal/BaseSlideOverModal.vue'
import BaseShowEditDateTimePicker from '@c/addf-package/components/BaseShowEditDatePicker/BaseShowEditDateTimePickerv2.vue'
import BaseShowEditInput from '@c/addf-package/components/BaseShowEditInput/BaseShowEditInput.vue'

export default {
  name: 'SupplierOrderReceiveOrderModal',
  components: {
    BaseShowEditInput,
    BaseShowEditDateTimePicker,
    BaseSlideOverModal,
    BaseButton
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    supplierId: {
      type: [String, Number],
      required: false,
      default: null
    },
    item: {
      type: Object,
      required: false,
      default: null
    },
    supplierOrderId: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  emits: ['refresh-supplier', 'close'],
  data() {
    return {
      items: [],
      save_item_receive: []
    }
  },
  computed: {
    ...mapGetters({
      supplierOrder: 'supplierOrder/getSupplierOrder',
      initialMetadata: 'metadata/getInitialMetadata',
      dossier: 'dossier/getDossier',
      errors: 'auth/getErrors'
    }),
    localOpen: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('update:open', value)
      }
    }
  },
  mounted() {
    this.items = this.supplierOrder.receive_items?.map((item) => item.id)
    this.save_item_receive = this.supplierOrder.receive_items?.map(
      (item) => item.id
    )
  },
  methods: {
    ...mapActions({
      processReceiveSupplierOrderAction: 'supplierOrder/receiveSupplierOrder'
    }),
    ...mapMutations({
      processSetSupplierOrderMutation: 'supplierOrder/setSupplierOrder',
      processRemoveSupplierOrderAtIndexMutation:
        'supplierOrder/removeSupplierOrderAtIndex',
      processSetErrorsMutation: 'auth/setErrors'
    }),
    canDeleteItem(supplier_order_item) {
      return (
        !(
          supplier_order_item.dossiers &&
          supplier_order_item.dossiers.length > 0
        ) && !this.items.includes(supplier_order_item.id)
      )
    },
    deleteItem(index) {
      this.processRemoveSupplierOrderAtIndexMutation(index)
    },
    toggleReceivingOrder(supplier_order_item) {
      if (this.items.includes(supplier_order_item.id)) {
        this.items = this.items.filter(
          (item_id) => item_id !== supplier_order_item.id
        )
        this.supplierOrder.receive_items =
          this.supplierOrder.receive_items.filter(
            (item) => item.id !== supplier_order_item.id
          )
      } else {
        this.items.push(supplier_order_item.id)
        this.supplierOrder.receive_items.push(supplier_order_item)
      }
    },
    receiveAllOrder() {
      this.items = this.supplierOrder.supplierOrderItems.map((item) => item.id)
      this.supplierOrder.receive_items = this.supplierOrder.supplierOrderItems
      this.handleReceiveOrder()
    },
    handleReceiveOrder() {
      this.processReceiveSupplierOrderAction({
        supplier_order_id: this.supplierOrder.id,
        supplier_order: this.supplierOrder,
        receive_item_ids: this.items
      }).then((response) => {
        this.processSetSupplierOrderMutation(response.supplier_order)
        this.$h.toastSuccess(this.$t('toasts.items_received'))
        this.$emit('refresh-supplier')
        this.close()
      })
    },
    close() {
      this.selectedSupplierOrderId = null
      this.processSetErrorsMutation({})
      this.$emit('close')
    }
  }
}
</script>
